export default __webpack_public_path__ + "media/invoice/stamp-refunded-b9daaa91.png";